export const isViewed = (element: HTMLElement) => {
  const { y, height } = element.getBoundingClientRect();
  const showcaseOffset = y + height / 2;
  return showcaseOffset < window.innerHeight;
};
